/** @format */

import { Component, EventEmitter, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef } from "ngx-bootstrap/modal";
import { RemitaRespondse } from "src/app/models/remiteResponse.model";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { RemitaPaymentService } from "src/app/Services/RemitaPaymentService";
import { ScriptService } from "src/app/Services/script-service.service";
import { ToastService } from "src/app/Services/ToastService";
import { environment } from "src/environments/environment";
import * as alertify from "alertifyjs";
import { AssessmentPaymentResponse } from "src/app/models/assessmentType";
import { ApiResponse } from "src/app/models/api-response";

declare const RmPaymentEngine: any;
@Component({
	selector: "app-property-payment-page",
	templateUrl: "./property-payment-page.component.html",
	styleUrls: ["./property-payment-page.component.css"],
})
export class PropertyPaymentPageComponent {
	@Output() onConfirmClicked = new EventEmitter();

	verifyForm: FormGroup;

	mdaExtendedRevenue: any[] = [];
	mdaList: any[] = [];
	mdaRecord: any = {};
	invoiceRecord: any = {};
	assessmentDetails: AssessmentPaymentResponse;
	isLoading: boolean = false;
	errorMessage: any;
	amount: number = 0;
	isVerifyingAsin: boolean = false;
	showAsinVerificationSuccessMessage: boolean;
	paymentType: string;
	invoiceDetailsProcessed: boolean = false;
	paymentMethod: string = "interswitch";
	isSubmitting: boolean;
	merchantCode = environment.merchantCode;
	payItemId = environment.payItemId;
	interSwitchMode = environment.interSwitchMode;
	remita: RemitaRespondse | any;
	isSubmittingAsinPayment: boolean;
	// assessmentId: string;

	revenueDetails: {
		code: string;
		id: number;
		description: string;
		feeDescription: string;
	} = {
		code: "51001001-12040152",
		id: 1049,
		description: "",
		feeDescription: "",
	};

	constructor(
		private fb: FormBuilder,
		private apiService: ApiServiceService,
		private route: ActivatedRoute,
		private router: Router,
		private remitaPaymentService: RemitaPaymentService,
		private spinner: ToastService,
		public modalRef: BsModalRef,
		private scriptService: ScriptService,
	) {}

	ngOnInit(): void {
		this.route.queryParamMap.subscribe((params) => {
			this.paymentType = params.get("paymentType");
		});

		this.initForm();
		this.getMdaRevenue("51001001");
	}

	initForm() {
		this.verifyForm = this.fb.group({
			asin: this.fb.control({ value: "", disabled: false }, [
				Validators.required,
			]),
			revenueId: this.fb.control(
				{ value: this.revenueDetails.id ?? 1049, disabled: true },
				[Validators.required],
			),
			revenueCode: this.fb.control(
				{
					value: this.revenueDetails.code ?? "51001001-12040152",
					disabled: true,
				},
				[Validators.required],
			),
			assessmentId: this.fb.control({ value: "", disabled: false }, [
				Validators.required,
			]),
		});
	}

	get asinControl() {
		return this.verifyForm.get("asin");
	}

	back() {
		this.router.navigate(["/"]);
	}

	getMdaRevenue(id: any) {
		const url = `/api/payment/split-account/all/revenues?id=${id}`;
		this.apiService.PaymentGet(url).subscribe({
			next: (response) => {
				this.mdaExtendedRevenue = response.map((item: any) => {
					if (item?.id === this.revenueDetails.id) {
						this.revenueDetails = {
							...item,
							code: item.revenueCode,
						};
					}

					return {
						...item,
						description: item.description
							.toLowerCase()
							.replace(/\b\w/g, (char: any) =>
								char.toUpperCase(),
							),
					};
				});
			},
			error: (error) => {
				console.log(error);
			},
		});
	}

	getMdaRecord(id: any) {
		this.mdaRecord = id;
	}

	submit() {
		this.isSubmittingAsinPayment = true;
		const returnBackUrl = environment.url + "/payment/successful-payment";
		var details = {
			returnBackUrl: returnBackUrl,
			totalAmount: Number(this.assessmentDetails?.amountDue),
			fullName: this.assessmentDetails?.taxpayerName,
			customerId: this.assessmentDetails.asin,
			revenueName: this.revenueDetails.description,
			revenueId: this.revenueDetails.code,
			emailOrPhone: this.assessmentDetails.email,
			taxGroup: "INDIVIDUAL",
			feeDescription: this.revenueDetails.description,
			entityName: this.revenueDetails.description,
			phoneNumber: this.verifyForm.value.phoneNumber,
			entityType: "NON MDA",
			entityGroup: "FLAT",
			accessedBy: this.assessmentDetails.taxpayerName,
			mdaRecordId: this.revenueDetails.id,
			assessmentId: this.assessmentDetails.assessmentId,
		};

		if (this.paymentMethod == "interswitch") {
			this.isSubmitting = true;
			this.startInterswitch(details);
		} else if (this.paymentMethod == "remita") {
			const details = {
				amount: Number(
					this.verifyForm.value.amount.split(",").join(""),
				),
				serviceTypeId: this.revenueDetails?.id,
				payerName: this.assessmentDetails.taxpayerName,
				payerEmail: this.assessmentDetails.email,
				payerPhone: this.verifyForm.value.emailOrPhone,
				revenueId: this.revenueDetails?.id,
				tin: this.assessmentDetails.asin,
			};
			this.startRemita(details);
		} else {
			this.isSubmitting = false;
			this.isSubmittingAsinPayment = false;
			alertify.set("notifier", "position", "top-center");
			alertify.error("Payment Gateway not available");
		}
	}

	isSubmittingInvoicePayment: boolean;
	submitInvoicePayment() {
		this.isSubmittingInvoicePayment = true;
	}

	userDetailsValidated: boolean;

	validatePropertyAssessment() {
		this.userDetailsValidated = false;
		const values = this.verifyForm.getRawValue();
		const url = "/assessments/apluc/validate/property-assessment";
		const payload = {
			asin: values.asin,
			assessmentId: values.assessmentId,
		};

		this.apiService.post(url, payload).subscribe({
			next: (res: ApiResponse<AssessmentPaymentResponse>) => {
				if (res == null) {
					alertify.set("notifier", "position", "top-center");
					alertify.error("Invalid ASIN / Property Number");
					return;
				}
				this.userDetailsValidated = true;
				this.assessmentDetails = res.data;
				this.isLoading = false;
				this.amount = res?.data?.amountDue;
				// this.assessmentId = this.verifyForm.getRawValue().assessmentId;
				this.verifyForm.get("asin")?.reset();
				this.verifyForm.get("assessmentId")?.reset();
			},
			error: (error) => {
				alertify.set("notifier", "position", "top-center");
				alertify.error(error ?? "Invalid ASIN / Property Number");
				this.isLoading = false;
				this.errorMessage = error.error.message;
			},
		});
	}

	clear() {
		this.assessmentDetails = null;
		this.amount = 0;
	}

	getType(e: any) {
		this.paymentMethod = e.target.value;
	}

	startInterswitch(details: any) {
		this.spinner.spin();
		this.remitaPaymentService.startInterswitchInline(details).subscribe(
			(response) => {
				this.spinner.hide();
				this.isSubmitting = false;
				this.scriptService.loadScript("switch_inline").then((r) => {
					this.checkout(details, response);
				});
			},
			(error) => {
				this.isSubmitting = false;
				console.info(`Remita Generate RRR error: ${error}`);
			},
		);
	}

	checkout(details: any, interswitch: any) {
		var paymentRequest = {
			merchant_code: this.merchantCode,
			pay_item_id: this.payItemId,
			txn_ref: interswitch.orderId,
			cust_id: details.customerId,
			amount:
				Math.round(
					(details?.totalAmount * 100 + Number.EPSILON) * 100,
				) / 100,
			currency: "566",
			site_redirect_url: window.location.origin,
			onComplete: (response: any) => {this.paymentCallback(response)},
			mode: this.interSwitchMode,
			split_accounts:
				this.interSwitchMode == "LIVE" &&
				!interswitch?.splitAccounts?.isEmpty
					? JSON.stringify(interswitch?.splitAccounts)
					: "",
		};
		(window as any).webpayCheckout(paymentRequest);
	}
	paymentCallback(response: any) {
		this.isSubmittingAsinPayment = false;
		if (
			response != null &&
			response.desc == "Approved by Financial Institution"
		) {
			sessionStorage.setItem("interResponse", JSON.stringify(response));
			setTimeout(() => {
				window.open(
					`/payment/return-back/${response.txnref}/${0.0}?assessmentType=PROPERTY_ASSESSMENT`,
					"_self",
				);
			}, 50);
		}
	}

	startRemita(details?: any) {
		this.scriptService.loadScript("remita_inline").then((r) => {
			this.generateRRR(details);
		});
	}

	generateRRR(details: any) {
		this.remitaPaymentService.generateRemitaRRR(details).subscribe(
			(value) => {
				this.isSubmittingAsinPayment = false;
				this.remita = value;
				this.loadRemitaIframe(this.remita);
			},
			(error) => {
				this.isSubmittingAsinPayment = false;
				this.spinner.hide();
			},
		);
	}

	loadRemitaIframe(remita: any): void {
		if (!remita) {
			return;
		}
		const paymentEngine = RmPaymentEngine.init({
			key: environment.remitaInLineKey,
			processRrr: true,
			transactionId: remita.orderId,
			extendedData: {
				autofill: true,
				customFields: [
					{
						name: "rrr",
						value: remita.rrr,
					},
				],
			},
			onSuccess: (response: any) => {
				const order = {
					orderId: remita.orderId,
					rrr: response.paymentReference,
					paymentReference: response.paymentReference,
					transactionId: response.transactionId,
					amount: remita.amount,
					responseurl: remita.responseurl,
				};
				this.remitaPaymentService.acknowledgementRRR(order).subscribe(
					(response) => {
						this.isSubmittingAsinPayment = false;
						// if (response.message =="Successful") {
						alertify.set("notifier", "position", "top-center");
						alertify.success("Payment Successful");
						setTimeout(() => {
							window.open(
								"/payment/return-back/" +
									remita.rrr +
									"/" +
									remita.amount,
								"_self",
							);
						}, 50);
					},
					(error) => {
						setTimeout(() => {
							alertify.set("notifier", "position", "top-center");
							alertify.error(response.message);
							this.close();
						}, 50);
					},
				);
			},
			onError: (response: any) => {
				setTimeout(() => {
					document.getElementById("closeRemitaPop")?.click();
				}, 3000);
				// this.openDialog(remita, invoice, false, index);
			},
			onClose: () => {},
		});
		paymentEngine.showPaymentWidget();
	}

	close() {
		this.onConfirmClicked.emit();
		this.modalRef.hide();
	}
}
